
export const hamburger = () => {
    const burger = document.querySelector('.h-top-mobile__hamburger');
    const tile = document.querySelector('.tile');
    const main = document.querySelector('main');

    if (!burger) return;

    burger.addEventListener('click', () => {
        burger.classList.toggle('h-top-mobile__hamburger--active');
        tile.classList.toggle('tile--active');
        if (main) main.classList.toggle('main--blur');
    });

}

